var map = {
	"./": 8305,
	"./App": 1853,
	"./App.jsx": 1853,
	"./App.scss": 5636,
	"./components/about": 9726,
	"./components/about/": 9726,
	"./components/about/index": 9726,
	"./components/about/index.jsx": 9726,
	"./components/about/index.scss": 5867,
	"./components/category": 919,
	"./components/category/": 919,
	"./components/category/index": 919,
	"./components/category/index.jsx": 919,
	"./components/category/index.scss": 2346,
	"./components/contacts": 8746,
	"./components/contacts/": 8746,
	"./components/contacts/index": 8746,
	"./components/contacts/index.jsx": 8746,
	"./components/contacts/index.scss": 9528,
	"./components/home": 8141,
	"./components/home/": 8141,
	"./components/home/index": 8141,
	"./components/home/index.jsx": 8141,
	"./components/home/index.scss": 6544,
	"./components/main": 5481,
	"./components/main/": 5481,
	"./components/main/index": 5481,
	"./components/main/index.jsx": 5481,
	"./components/main/index.scss": 6157,
	"./components/product": 1252,
	"./components/product/": 1252,
	"./components/product/index": 1252,
	"./components/product/index.jsx": 1252,
	"./components/product/index.scss": 969,
	"./components/sidebar": 5417,
	"./components/sidebar/": 5417,
	"./components/sidebar/index": 5417,
	"./components/sidebar/index.jsx": 5417,
	"./components/sidebar/index.scss": 2889,
	"./constants/data": 2483,
	"./constants/data.js": 2483,
	"./constants/links": 1726,
	"./constants/links.js": 1726,
	"./fonts/Montserrat/Montserrat-VariableFont_wght.ttf": 5166,
	"./img/background/1.jpg": 2972,
	"./img/background/2.jpg": 7325,
	"./img/background/3.jpg": 7046,
	"./img/background/4.jpg": 6478,
	"./img/background/brama.jpg": 2793,
	"./img/background/klevie.jpg": 4608,
	"./img/background/ribprom.jpg": 5517,
	"./img/brama/brama_baursak.png": 8192,
	"./img/brama/brama_bitochki.png": 1735,
	"./img/brama/brama_nuggets.png": 6637,
	"./img/brama/brama_pelmeni_farsh_soma.jpg": 2638,
	"./img/brama/brama_pelmeni_lososeviy_farsh.jpg": 5041,
	"./img/brama/brama_pelmeni_pasta_iz_lesha_originalnie.jpg": 8168,
	"./img/brama/brama_pelmeni_pasta_iz_lesha_prazdnichnie.jpg": 8973,
	"./img/brama/brama_pelmeni_s_farshem_sudaka.jpg": 521,
	"./img/brama/brama_strips.png": 9485,
	"./img/heinz.png": 1365,
	"./img/klevie/klevie_lesh.png": 2198,
	"./img/klevie/klevie_lesh_spinka.jpg": 9778,
	"./img/klevie/klevie_polukolca_kopchenie.jpg": 3574,
	"./img/klevie/klevie_solomka_kalmara.jpg": 3785,
	"./img/klevie/klevie_struzhka_kalmara.jpg": 2145,
	"./img/klevie/klevie_vobla.png": 7598,
	"./img/klevie/klevie_vobla_spinka.jpg": 2551,
	"./img/logo.png": 1053,
	"./img/ribprom/farsh_ribniy.png": 3280,
	"./img/ribprom/file_okunya.png": 8362,
	"./img/ribprom/file_sazana.png": 1394,
	"./img/ribprom/file_shyki.png": 9874,
	"./img/ribprom/file_soma.png": 5357,
	"./img/ribprom/file_sudaka.png": 8104,
	"./img/ribprom/file_zmeegolova.png": 4069,
	"./img/ribprom/shechki_sudaka.png": 5909,
	"./img/ribprom/tushka_karasya.jpg": 7519,
	"./img/ribprom/tushka_sazana.jpeg": 9738,
	"./img/sidebar/about.svg": 3553,
	"./img/sidebar/contacts.svg": 2427,
	"./img/sidebar/fish_snacks.svg": 7088,
	"./img/sidebar/frozen.svg": 9022,
	"./img/sidebar/half_made.svg": 5231,
	"./index": 8305,
	"./index.js": 8305,
	"./reportWebVitals": 4013,
	"./reportWebVitals.js": 4013,
	"./scss/variables.scss": 9073,
	"./setupTests": 9511,
	"./setupTests.js": 9511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8116;